// ─────────────────────────────────────────────────────────────────────────────
// Auth feature — API давхарга. Нэвтрэх + нууц үг баталгаажуулах.
// ─────────────────────────────────────────────────────────────────────────────
import AxiosRequest from "shared/api/httpClient";

/** Мерчант нэвтрэх. data: { loginName, loginPassword, role }. */
export async function login(data) {
  return AxiosRequest({ url: "/merchant/login", method: "post", data });
}

/** Нууц үг баталгаажуулах (устгах/эмзэг үйлдлийн өмнө). body: { password }. */
export async function verifyPassword(body) {
  return AxiosRequest({
    url: "/merchant/password/verify",
    method: "post",
    data: body,
  });
}
